<template>
  <div class="mt-4 px-4 container-fluid">
    <div class="breadcrumb text-md px-0 mb-4">
      <p><span class="breadcrumb-item" @click="irInicio">Inicio</span> > Devoluciones</p>
    </div>
  </div>

  <!-- =========================
       1) DEVOLUCIONES REALIZADAS
       ========================= -->
  <div class="px-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card ficha-buscador">
          <div class="titulo">
            <h5 class="mx-4 mt-5 mb-5">Devoluciones realizadas</h5>
          </div>

          <div class="table-search">
            <input
              id="textoBuscadorDev"
              type="text"
              class="form-control"
              placeholder="Buscar refund, pi_, referencia, email, nota..."
              aria-label="Buscar devolución"
              autocomplete="off"
              readonly
              @focus="$event.target.removeAttribute('readonly')"
              @input="teclearBuscadorDevoluciones"
            />
          </div>

          <div class="d-flex align-items-center gap-2 ms-3 flex-wrap dev-filter-row">
            <select v-model="devStatus" class="form-select form-select-sm dev-filter-select" @change="onFiltroCambiado()">
              <option value="">Todos</option>
              <option value="pending">pending</option>
              <option value="succeeded">succeeded</option>
              <option value="failed">failed</option>
              <option value="canceled">canceled</option>
            </select>

            <input v-model="devDesde" type="date" class="form-control form-control-sm dev-filter-date" @change="onFiltroCambiado()" />
            <input v-model="devHasta" type="date" class="form-control form-control-sm dev-filter-date" @change="onFiltroCambiado()" />
          </div>

        </div>
      </div>
    </div>
  </div>

  <div class="px-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card ficha-listado mt-4">
          <div class="px-4 pb-0 card-body">
            <div class="table-responsive mb-4">

              <div v-if="devError" class="alert alert-danger py-2">{{ devError }}</div>

              <table class="table table-flush table-listado">
                <thead class="thead-light">
                  <tr>
                    <th class="d-none d-md-table-cell">Fecha</th>
                    <th class="d-none d-md-table-cell">Pedido</th>
                    <th>Servicio</th>
                    <th class="d-none d-md-table-cell">Tipster</th>
                    <th class="d-none d-md-table-cell">Cliente</th>
                    <th>Importe</th>
                    <th>Status</th>
                    <th class="d-none d-md-table-cell">Stripe</th>
                  </tr>
                </thead>
                <tbody class="text-sm">
                  <tr v-for="r in devolucionesRows" :key="r.id">
                    <td class="d-none d-md-table-cell">{{ fmtFecha(r.created_at) }}</td>
                    <td class="d-none d-md-table-cell">{{ r.pedido_referencia ?? r.pedido?.referencia ?? '-' }}</td>
                    <td>{{ r.producto_nombre ?? '-' }}</td>
                    <td class="d-none d-md-table-cell">{{ r.tipster_nombre ?? '-' }}</td>
                    <td class="d-none d-md-table-cell">{{ r.cliente_email ?? '-' }}</td>
                    <td>{{ fmtMoney(r.amount, r.currency) }}</td>
                    <td><span class="badge" :class="badgeClass(r.status)">{{ r.status }}</span></td>
                    <td class="d-none d-md-table-cell text-xs">
                      <div class="mono">pi: {{ r.stripe_payment_intent ?? '-' }}</div>
                      <div class="mono">re: {{ r.stripe_refund_id ?? '-' }}</div>
                    </td>
                  </tr>

                  <tr v-if="devolucionesRows.length === 0">
                    <td colspan="8">No hay devoluciones que mostrar</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- paginación devoluciones -->
            <div class="paginacion" v-if="devolucionesTotal > 0">
              <p class="contador-listado">
                Mostrando {{ devolucionesMostIni }} a {{ devolucionesMostFin }} de {{ devolucionesTotal }} registros
              </p>

              <ul class="pagination pagination-md" v-if="devolucionesLastPage > 1">
                <li class="page-item prev-page" v-if="devolucionesPaginaActual > 1">
                  <a class="page-link" @click="devolucionesPaginaActual--; fetchDevoluciones()">
                    <i class="fa fa-angle-left"></i>
                  </a>
                </li>
                <li v-for="p in devolucionesRangoPaginas" :key="p" class="page-item" :class="p===devolucionesPaginaActual ? 'active disabled' : ''">
                  <a class="page-link" @click="devolucionesPaginaActual=p; fetchDevoluciones()">{{ p }}</a>
                </li>
                <li class="page-item next-page" v-if="devolucionesPaginaActual < devolucionesLastPage">
                  <a class="page-link" @click="devolucionesPaginaActual++; fetchDevoluciones()">
                    <i class="fa fa-angle-right"></i>
                  </a>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- =========================
       2) TRANSACCIONES / PEDIDOS
       ========================= -->
  <div class="px-4 container-fluid mt-5">
    <div class="row">
      <div class="col-12">
        <div class="card ficha-buscador">
          <div class="titulo">
            <h5 class="mx-4 mt-5 mb-5">Transacciones (Pedidos confirmados)</h5>
          </div>

          <div class="table-search">
            <input
              id="textoBuscadorTrans"
              type="text"
              class="form-control"
              placeholder="Búsqueda rápida..."
              aria-label="Buscar transacción"
              autocomplete="off"
              readonly
              @focus="$event.target.removeAttribute('readonly')"
              @input="teclearBuscadorTransacciones"
            />
          </div>

          <div
            v-if="mostrarFiltroTipster || mostrarFiltroProducto"
            class="filtros-trans-row"
          >
            <select
              v-if="mostrarFiltroTipster"
              v-model="transTipsterId"
              class="form-control form-control-sm filtro-trans-select"
              @change="onCambioTipster"
            >
              <option value="">Todos los tipsters</option>
              <option
                v-for="tip in filtrosTipsters"
                :key="tip.id"
                :value="tip.id"
              >
                {{ tip.nombre }}
              </option>
            </select>

            <select
              v-if="mostrarFiltroProducto"
              v-model="transProductoId"
              class="form-control form-control-sm filtro-trans-select filtro-trans-producto"
              :disabled="productoFiltroDeshabilitado"
              @change="onCambioProducto"
            >
              <option value="">Todos los productos</option>
              <option
                v-for="prod in filtrosProductos"
                :key="prod.id"
                :value="prod.id"
              >
                {{ prod.nombre }}
              </option>
            </select>
          </div>
          <div
            v-if="mostrarSeleccionMasiva && transSeleccionados.length"
            class="masiva-accion-row"
          >
            <button
              class="btn btn-sm btn-danger btn-masiva"
              @click="abrirModalDevolucionMasiva"
            >
              Devolver seleccionados ({{ transSeleccionados.length }})
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="px-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card ficha-listado mt-4">
          <div class="px-4 pb-0 card-body">
            <div class="table-responsive mb-4">
              <table id="Trans-list" class="table table-flush table-listado">
               <thead class="thead-light">
                  <tr>
                    <th class="th-sort" @click="toggleSort(0)">Fecha <span class="sort-icon">{{ sortIcon(0) }}</span></th>
                    <th class="th-sort d-none d-md-table-cell" @click="toggleSort(1)">Referencia <span class="sort-icon">{{ sortIcon(1) }}</span></th>
                    <th class="d-none d-lg-table-cell">Email</th>
                    <th class="th-sort" @click="toggleSort(2)">Producto <span class="sort-icon">{{ sortIcon(2) }}</span></th>
                    <th v-if="mostrarFiltroTipster" class="th-sort d-none d-md-table-cell" @click="toggleSort(3)">Tipster <span class="sort-icon">{{ sortIcon(3) }}</span></th>
                    <th class="th-sort d-none d-md-table-cell" @click="toggleSort(4)">Precio <span class="sort-icon">{{ sortIcon(4) }}</span></th>
                    <th class="th-sort" @click="toggleSort(5)">Estado <span class="sort-icon">{{ sortIcon(5) }}</span></th>
                    <th class="d-none d-md-table-cell">Se unió</th>
                    <th class="d-none d-lg-table-cell">Telegram ID</th>
                    <th class="sin-orden">Acc.</th>
                    <th v-if="mostrarSeleccionMasiva" class="sin-orden" style="width:40px">
                      <input
                        type="checkbox"
                        :checked="todosSeleccionados"
                        @change="toggleSeleccionTodos"
                      />
                    </th>
                  </tr>
                </thead>
                <tbody class="text-sm">
                    <tr v-for="row in transRows" :key="row.id">
                      <td>{{ row.fecha }}</td>
                      <td class="d-none d-md-table-cell">{{ row.referencia }}</td>
                      <td class="d-none d-lg-table-cell">{{ row.email || '-' }}</td>
                      <td>{{ row.producto }}</td>
                      <td class="d-none d-md-table-cell" v-if="mostrarFiltroTipster">{{ row.tipster }}</td>
                      <td class="d-none d-md-table-cell">{{ row.precio }}</td>
                      <td>{{ row.estado }}</td>

                      <td class="d-none d-md-table-cell">
                        <span class="badge" :class="row.seUnio ? 'badge-ok' : 'badge-muted'">
                          {{ row.seUnio ? 'Sí' : 'No' }}
                        </span>
                      </td>

                      <td class="mono d-none d-lg-table-cell">{{ row.telegramId ?? '-' }}</td>

                      <td>
                       <a
                          href="#"
                          class="cursor-pointer me-3"
                          :class="{ 'disabled-link': pedidoYaDevuelto(row.id) }"
                          :title="pedidoYaDevuelto(row.id) ? 'Este pedido ya tiene devolución' : 'Crear devolución'"
                          @click.prevent="pedidoYaDevuelto(row.id) ? null : abrirDevolucion(row.id, row.precio)"
                        >
                          <i
                            class="fas fa-rotate-left"
                            :class="pedidoYaDevuelto(row.id) ? 'text-secondary' : 'text-danger'"
                          ></i>
                        </a>
                      </td>
                      <td v-if="mostrarSeleccionMasiva">
                        <input
                          type="checkbox"
                          :checked="transSeleccionados.includes(Number(row.id))"
                          :disabled="pedidoYaDevuelto(row.id)"
                          @change="toggleSeleccionFila(row.id)"
                        />
                      </td>
                    </tr>

                    <tr v-if="transRows.length==0">
                      <td :colspan="mostrarSeleccionMasiva ? (mostrarFiltroTipster ? 11 : 10) : (mostrarFiltroTipster ? 10 : 9)">
                        No hay transacciones que mostrar
                      </td>
                    </tr>
                  </tbody>
              </table>
            </div>

            <!-- Paginación transacciones -->
            <div class="paginacion" v-if="transMostTotal>0">
              <p class="contador-listado">Mostrando {{ transMostIni }} a {{ transMostFin }} de {{ transMostTotal }} registros</p>

              <ul class="pagination pagination-md" v-if="transPaginaTotal>1">
                <li class="page-item prev-page" v-if="transPaginaActual>1">
                  <a class="page-link" @click="transPaginaActual--; fetchTransacciones();">
                    <i class="fa fa-angle-left"></i>
                  </a>
                </li>
                <li v-for="index in transRangoPaginas" :key="index" class="page-item" :class="index==transPaginaActual ? 'active disabled' : ''">
                  <a class="page-link" @click="transPaginaActual=index; fetchTransacciones();">{{index}}</a>
                </li>
                <li class="page-item next-page" v-if="transPaginaActual<transPaginaTotal">
                  <a class="page-link" @click="transPaginaActual++; fetchTransacciones();">
                    <i class="fa fa-angle-right"></i>
                  </a>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- MODAL -->
  <Modal @cerrar-modal="cerrarModal" :modalActive="modalActive">
    <div class="modal-content">
      <crear-devolucion-form
        v-if="modalActive"
        :pedidoId="pedidoADevolverId"
        :pedidoTotal="pedidoADevolverTotal"
        @ok="onDevolucionOk"
        @cerrar-modal="cerrarModal"
      />
    </div>
  </Modal>
  <Modal @cerrar-modal="cerrarModalMasiva" :modalActive="modalMasivaActiva">
  <div class="modal-content p-3">
    <h5 class="mb-3">Confirmar devolución masiva</h5>

    <div class="mb-2 text-sm" v-if="mostrarFiltroTipster">
      <strong>Tipster:</strong> {{ tipsterSeleccionadoNombre }}
    </div>
    <div class="mb-2 text-sm">
      <strong>Producto:</strong> {{ productoSeleccionadoNombre }}
    </div>
    <div class="mb-2 text-sm">
      <strong>Pedidos seleccionados:</strong> {{ transSeleccionados.length }}
    </div>
    <div class="mb-3 text-sm">
      <strong>Importe estimado:</strong> {{ importeTotalSeleccionado.toFixed(2) }} EUR
    </div>

    <div class="mb-3">
      <label class="form-label text-xs">Motivo</label>
      <select v-model="reasonMasiva" class="form-control">
        <option value="requested_by_customer">Solicitado por el cliente</option>
        <option value="duplicate">Pago duplicado</option>
        <option value="fraudulent">Fraudulento</option>
      </select>
    </div>

    <div class="mb-3">
      <label class="form-label text-xs">Nota interna (opcional)</label>
      <textarea v-model="notaMasiva" class="form-control" rows="3" placeholder="Motivo interno / auditoría"></textarea>
    </div>

    <div class="mb-3">
      <label class="form-label text-xs">Confirma tu contraseña</label>
      <input
        v-model="passwordConfirmacion"
        type="password"
        class="form-control"
        placeholder="Introduce tu contraseña"
      />
    </div>

    <div v-if="devError" class="alert alert-danger py-2">{{ devError }}</div>

    <div class="d-flex justify-content-end gap-2">
      <button class="btn btn-sm btn-outline-secondary" @click="cerrarModalMasiva">
        Cancelar
      </button>
      <button class="btn btn-sm btn-danger" :disabled="procesandoMasiva" @click="ejecutarDevolucionMasiva">
        {{ procesandoMasiva ? "Procesando..." : "Confirmar devolución masiva" }}
      </button>
    </div>
  </div>
</Modal>
</template>

<script>
import Modal from "./components/Modal.vue";
import CrearDevolucionForm from "./components/CrearDevolucionForm.vue";
import { listarDevoluciones, listarPedidosBloqueadosDevolucion, obtenerFiltrosDevoluciones, crearDevolucionMasiva } from "@/services/devoluciones";
import {globalFunctionsMixin} from '@/mixins/globalFunctions.js';
import showSwal from "@/mixins/showSwal.js";

export default {
  name: "Devoluciones",
  components: { Modal, CrearDevolucionForm },
  mixins: [globalFunctionsMixin, showSwal],
  data() {
    return {
      transSeleccionados: [],
      modalMasivaActiva: false,
      passwordConfirmacion: "",
      notaMasiva: "",
      reasonMasiva: "requested_by_customer",
      procesandoMasiva: false,
      // ---- DEVOLUCIONES (arriba)
      devTextoBuscador: "",
      devStatus: "",
      devDesde: "",
      devHasta: "",
      devolucionesRows: [],
      devolucionesPaginaActual: 1,
      devolucionesPerPage: 10,
      devolucionesLastPage: 1,
      devolucionesTotal: 0,
      devolucionesMostIni: 0,
      devolucionesMostFin: 0,
      devError: "",
      // ---- TRANSACCIONES (abajo)
      transTextoBuscador: "",
      transRows: [],
      transPaginaActual: 1,
      transPaginaTotal: 1,
      transMostIni: 0,
      transMostFin: 0,
      transMostTotal: 0,
      transSortCol: 0,
      transSortDir: "desc",

      transTipsterId: "",
      transProductoId: "",
      filtrosTipsters: [],
      filtrosProductos: [],

      // ---- BLOQUEO REAL DESDE BD
      pedidosBloqueados: new Set(),
      pedidoADevolverTotal: null,
      // ---- MODAL
      modalActive: false,
      pedidoADevolverId: null,

      // debounce
      debounceDev: null,
      debounceTrans: null,
    };
  },
  computed: {
    miRol() { return this.$store.getters["auth/rolEfectivo"]; },
    mostrarSeleccionMasiva() {
      if (this.miRol === 1 || this.miRol === 2) {
        return !!this.transTipsterId && !!this.transProductoId;
      }
      // Tipster: su tipster_id es automático, solo necesita seleccionar producto
      if (this.miRol === 4) {
        return !!this.transProductoId;
      }
      return false;
    },

    filasSeleccionables() {
      return this.transRows.filter(row => !this.pedidoYaDevuelto(row.id));
    },

    todosSeleccionados() {
      return this.filasSeleccionables.length > 0 &&
        this.filasSeleccionables.every(row => this.transSeleccionados.includes(Number(row.id)));
    },

    importeTotalSeleccionado() {
      return this.transRows
        .filter(row => this.transSeleccionados.includes(Number(row.id)))
        .reduce((acc, row) => acc + Number(row.precio || 0), 0);
    },

    tipsterSeleccionadoNombre() {
      const x = this.filtrosTipsters.find(t => Number(t.id) === Number(this.transTipsterId));
      return x?.nombre || "-";
    },

    productoSeleccionadoNombre() {
      const x = this.filtrosProductos.find(p => Number(p.id) === Number(this.transProductoId));
      return x?.nombre || "-";
    },
    devolucionesRangoPaginas() {
      const start = Math.max(this.devolucionesPaginaActual - 3, 1);
      const end = Math.min(this.devolucionesPaginaActual + 3, this.devolucionesLastPage);
      const pages = [];
      for (let i = start; i <= end; i++) pages.push(i);
      return pages;
    },
    transRangoPaginas() {
      const start = Math.max(this.transPaginaActual - 3, 1);
      const end = Math.min(this.transPaginaActual + 3, this.transPaginaTotal);
      const pages = [];
      for (let i = start; i <= end; i++) pages.push(i);
      return pages;
    },

    mostrarFiltroTipster() {
      return this.miRol === 1 || this.miRol === 2;
    },

    mostrarFiltroProducto() {
      return this.miRol === 1 || this.miRol === 2 || this.miRol === 4;
    },

    productoFiltroDeshabilitado() {
      if (this.mostrarFiltroTipster) {
        return !this.transTipsterId;
      }
      return false;
    },
  },
  methods: {
    async ejecutarDevolucionMasiva() {
      if (!this.transSeleccionados.length) {
        this.devError = "No hay pedidos seleccionados.";
        return;
      }

      if (!this.passwordConfirmacion.trim()) {
        this.devError = "Debes introducir tu contraseña.";
        return;
      }

      this.procesandoMasiva = true;
      this.devError = "";

      try {
        await crearDevolucionMasiva({
          pedido_ids: this.transSeleccionados,
          password: this.passwordConfirmacion,
          reason: this.reasonMasiva || undefined,
          nota: this.notaMasiva || undefined,
          tipster_id: this.transTipsterId || undefined,
          producto_id: this.transProductoId || undefined,
        });

        this.cerrarModalMasiva();
        this.limpiarSeleccionMasiva();

        await this.fetchPedidosBloqueados();
        await this.fetchDevoluciones();
        await this.fetchTransacciones();

        this.showSwal({
          type: "success",
          message: "Devoluciones encoladas. Recibirás un email cuando se completen.",
          width: 520,
          timer: 8000,
        });
      } catch (e) {
        this.devError = e?.response?.data?.mensaje || "Error en devolución masiva";
      } finally {
        this.procesandoMasiva = false;
      }
    },
    toggleSeleccionFila(id) {
      const n = Number(id);
      if (this.transSeleccionados.includes(n)) {
        this.transSeleccionados = this.transSeleccionados.filter(x => x !== n);
      } else {
        this.transSeleccionados = [...this.transSeleccionados, n];
      }
    },

    toggleSeleccionTodos() {
      if (this.todosSeleccionados) {
        this.transSeleccionados = [];
      } else {
        this.transSeleccionados = this.filasSeleccionables.map(r => Number(r.id));
      }
    },

    abrirModalDevolucionMasiva() {
      this.passwordConfirmacion = "";
      this.notaMasiva = "";
      this.reasonMasiva = "requested_by_customer";
      this.modalMasivaActiva = true;
    },

    cerrarModalMasiva() {
      this.modalMasivaActiva = false;
      this.passwordConfirmacion = "";
      this.notaMasiva = "";
    },

    limpiarSeleccionMasiva() {
      this.transSeleccionados = [];
    },
    async cargarFiltrosTransacciones(tipsterId = "") {
      try {
        const payload = {};

        if (tipsterId) {
          payload.tipster_id = Number(tipsterId);
        }

        const resp = await obtenerFiltrosDevoluciones(payload);
        const data = resp?.data?.data ?? {};

        this.filtrosTipsters = Array.isArray(data.tipsters) ? data.tipsters : [];
        this.filtrosProductos = Array.isArray(data.productos) ? data.productos : [];
      } catch (e) {
        console.error("Error cargando filtros de devoluciones", e);
        this.filtrosTipsters = [];
        this.filtrosProductos = [];
      }
    },
    async onCambioTipster() {
      this.transSeleccionados = [];
      this.transProductoId = "";
      this.transPaginaActual = 1;
      await this.cargarFiltrosTransacciones(this.transTipsterId);
      await this.fetchTransacciones();
    },

    async onCambioProducto() {
      this.transPaginaActual = 1;
      this.transSeleccionados = [];
      await this.fetchTransacciones();
    },
    async fetchPedidosBloqueados() {
      try {
        const resp = await listarPedidosBloqueadosDevolucion({});
        const ids = Array.isArray(resp?.data?.data) ? resp.data.data : [];
        this.pedidosBloqueados = new Set(ids.map(id => Number(id)));
      } catch (e) {
        console.error("Error cargando pedidos bloqueados por devolución", e);
        this.pedidosBloqueados = new Set();
      }
    },

    pedidoYaDevuelto(pedidoId) {
      return this.pedidosBloqueados.has(Number(pedidoId));
    },
    irInicio() {
      this.$router.push("/dashboard");
    },

    // Filtros de status/fecha: resetear página antes de buscar
    onFiltroCambiado() {
      this.devolucionesPaginaActual = 1;
      this.fetchDevoluciones();
    },

    // ---------- DEVOLUCIONES (arriba)
    teclearBuscadorDevoluciones(event) {
      this.devTextoBuscador = event.target.value;
      this.transSeleccionados = [];
      clearTimeout(this.debounceDev);
      this.debounceDev = setTimeout(() => {
        this.devolucionesPaginaActual = 1;
        this.fetchDevoluciones();
      }, 450);
    },

    async fetchDevoluciones() {
      try {
        this.devError = "";

        const payload = {
          paginaActual: this.devolucionesPaginaActual,
          perPage: this.devolucionesPerPage,
          textoBuscador: this.devTextoBuscador,
          status: this.devStatus || undefined,
          desde: this.devDesde || undefined,
          hasta: this.devHasta || undefined,
          sortColumn: "pd.created_at",
          sortDirection: "desc",
        };

        const resp = await listarDevoluciones(payload);

        // tu formato: resp.data = { res:"OK", data:{paginate} }
        const pag = resp?.data?.data ?? {};

        this.devolucionesRows = Array.isArray(pag.data) ? pag.data : [];
        this.devolucionesTotal = Number(pag.total || 0);
        this.devolucionesLastPage = Number(pag.last_page || 1);

        if (this.devolucionesTotal > 0) {
          this.devolucionesMostIni = (this.devolucionesPaginaActual - 1) * this.devolucionesPerPage + 1;
          this.devolucionesMostFin = Math.min(this.devolucionesTotal, this.devolucionesPaginaActual * this.devolucionesPerPage);
        } else {
          this.devolucionesMostIni = 0;
          this.devolucionesMostFin = 0;
        }
      } catch (e) {
        this.devError = e?.response?.data?.mensaje || "Error cargando devoluciones";
      }
    },

    
    teclearBuscadorTransacciones(event) {
      this.transTextoBuscador = event.target.value;
      clearTimeout(this.debounceTrans);
      this.debounceTrans = setTimeout(() => {
        this.transPaginaActual = 1;
        this.transSeleccionados = [];
        this.fetchTransacciones();
      }, 450);
    },

    toggleSort(col) {
      if (this.transSortCol === col) {
        this.transSortDir = this.transSortDir === "asc" ? "desc" : "asc";
      } else {
        this.transSortCol = col;
        this.transSortDir = "desc";
      }
      this.transPaginaActual = 1;
      this.fetchTransacciones();
    },
    sortIcon(col) {
      if (this.transSortCol !== col) return "⇅";
      return this.transSortDir === "asc" ? "↑" : "↓";
    },

    async fetchTransacciones() {
      const response = await this.$store.dispatch("auth/pedidos", {
        textoBuscador: this.transTextoBuscador,
        paginaActual: this.transPaginaActual,
        mostrarBorrados: false,
        sortColumn: this.transSortCol,
        sortDirection: this.transSortDir,
        tipster_id: this.transTipsterId || undefined,
        producto_id: this.transProductoId || undefined,
      });
      this.transSeleccionados = [];
      const estados = { P: "No finalizado", C: "Confirmado" };
      const soloConfirmados = (response.data || []).filter(r => r.estado === "C");

      this.transRows = soloConfirmados.map(row => ({
        id: row.id,
        referencia: row.referencia,
        email: row.email || row.cliente_email || row.user_email || null,

        producto: row.producto,
        precio: row.precio,
        tipster: row.tipster,
        estado: estados[row.estado] || row.estado,
        fecha: this.formatDate(row.fecha, "DD/MM/YYYY HH:mm:ss"),
          seUnio: Boolean(
          row.se_unio_al_canal ??
          row.se_unio ??
          row.joined ??
          row.joined_channel ??
          row.usado_enlace ??
          0
        ),

        // ✅ NUEVO: telegram id (depende de tu backend)
        telegramId: row.telegram_id ?? row.telegramId ?? row.user_telegram_id ?? null,
      }));

      this.transPaginaTotal = response.paginas || 1;
      this.transMostIni = (response.actual - 1) * response.porpagina + 1;
      this.transMostFin = Math.min(response.totales, response.actual * response.porpagina);
      this.transMostTotal = response.totales;
    },

    // ---------- MODAL devoluciones
    abrirDevolucion(pedidoId, pedidoTotal = null) {
      this.pedidoADevolverId = pedidoId;
      this.pedidoADevolverTotal = pedidoTotal;
      this.modalActive = true;
    },
    cerrarModal() {
      this.modalActive = false;
      this.pedidoADevolverId = null;
      this.pedidoADevolverTotal = null;
    },
    async onDevolucionOk() {
      await this.fetchPedidosBloqueados();
      await this.fetchDevoluciones();
      await this.fetchTransacciones();
      this.cerrarModal();
    },

    // helpers visuales
    badgeClass(status) {
      const s = (status || "").toLowerCase();
      if (s === "succeeded") return "badge-ok";
      if (s === "pending")   return "badge-warn";
      if (s === "failed")    return "badge-err";
      if (s === "canceled")  return "badge-muted";
      return "badge-muted";
    },
    fmtFecha(v) {
      if (!v) return "-";
      return String(v).replace("T", " ").slice(0, 16);
    },
    fmtMoney(amount, currency) {
      if (amount == null) return "-";
      const cur = (currency || "").toUpperCase();
      return `${amount} ${cur}`.trim();
    },
  },

  watch: {
    async miRol(nuevoRol) {
      if (nuevoRol === 4 && !this.transTipsterId) {
        this.transTipsterId = Number(localStorage.getItem("usuarioTipsterId") || 0) || "";
      }
      if (nuevoRol > 0 && (this.mostrarFiltroTipster || this.mostrarFiltroProducto)) {
        await this.cargarFiltrosTransacciones(this.transTipsterId);
      }
    },
  },

  async mounted() {
    this.$store.commit('setShowFooter', true);

    // Para tipsters: precargar su propio tipster_id (no tienen select de tipster)
    if (this.miRol === 4) {
      this.transTipsterId = Number(localStorage.getItem("usuarioTipsterId") || 0) || "";
    }

    if (this.mostrarFiltroTipster || this.mostrarFiltroProducto) {
      await this.cargarFiltrosTransacciones(this.transTipsterId);
    }

    await this.fetchPedidosBloqueados();
    await this.fetchDevoluciones();
    await this.fetchTransacciones();
  },
};
</script>

<style scoped>
/* ── Badges Terminal Nocturna ──────────────────── */
.badge-ok, .badge-warn, .badge-err, .badge-muted {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 20px;
  font-size: 0.72rem;
  font-weight: 700;
  border: 1px solid transparent;
  white-space: nowrap;
}
.badge-ok   { background: var(--q-green-soft); border-color: var(--q-green); color: var(--q-green); }
.badge-warn { background: var(--q-amber-soft); border-color: var(--q-amber); color: var(--q-amber); }
.badge-err  { background: var(--q-red-soft);   border-color: var(--q-red);   color: var(--q-red);   }
.badge-muted{ background: var(--q-hover);       border-color: var(--q-border-md); color: var(--q-muted); }

/* ── Date inputs — ícono calendario visible en dark ── */
input[type="date"].form-control,
input[type="date"].form-control-sm {
  color-scheme: dark;
}

.mono {
  font-family: var(--q-font-mono);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.disabled-link {
  pointer-events: none;
  opacity: 0.55;
  cursor: not-allowed;
}
select.form-select,
select.form-control {
  background-image: none !important;
  -webkit-appearance: menulist !important;
  -moz-appearance: menulist !important;
  appearance: menulist !important;
  padding-right: 0.75rem !important;
}
.dev-filter-select { max-width: 180px; }
.dev-filter-date   { max-width: 160px; }

/* Inputs de búsqueda plain */
.table-search .form-control {
  width: 100%;
  max-width: 480px;
}

/* Fila de filtros transacciones */
.filtros-trans-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 0 12px 12px 12px;
}
.filtro-trans-select     { max-width: 220px; }
.filtro-trans-producto   { max-width: 280px; }

/* Botón devolución masiva */
.masiva-accion-row {
  display: flex;
  justify-content: flex-end;
  padding: 0 12px 12px 12px;
}

@media (max-width: 540px) {
  /* Filtros de devoluciones realizadas */
  .dev-filter-select,
  .dev-filter-date { max-width: 100%; width: 100%; }

  /* Fila de filtros de estado/fechas — ancho completo sin margen izquierdo */
  .dev-filter-row { margin-left: 0 !important; width: 100%; padding: 0 12px 12px; }

  /* Input de búsqueda */
  .table-search .form-control { max-width: 100%; }

  /* Filtros transacciones */
  .filtros-trans-row { flex-direction: column; align-items: stretch; padding: 0 8px 12px; }
  .filtro-trans-select,
  .filtro-trans-producto { max-width: 100%; width: 100%; }

  /* Botón masiva */
  .masiva-accion-row { justify-content: stretch; padding: 0 8px 12px; }
  .btn-masiva { width: 100%; }
}

/* Columnas ordenables */
.th-sort {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}
.th-sort:hover { background: var(--q-hover); }
.sort-icon {
  font-size: 0.75rem;
  opacity: 0.6;
  margin-left: 3px;
}
</style>